export default __webpack_public_path__ + "static/media/Deed of Contract_08.1e7d1224.jpg";